// extracted by mini-css-extract-plugin
module.exports = {"formHolder":"QrCodeWithFactor_formHolder__QLSVr","TextAreaHolder":"QrCodeWithFactor_TextAreaHolder__3ghck","ButtonHolder":"QrCodeWithFactor_ButtonHolder__z7NmS"};